package one.healthium.profile.ui.food.models

import androidx.compose.runtime.Immutable
import one.healthium.domain.user.models.FoodOptions
import one.healthium.loco.LString
import kotlin.math.roundToInt
import kotlin.time.Instant

@Immutable
data class FoodUiOptions(
    val amount: AmountUiModel,
    val food: FoodUiModel,
    val date: Instant,
) {
    val amountGrams = amount.grams
    val foodName = food.product

    val calories = food.calories * amount.hundredGrams
    val caloriesDisplayValue = calories.roundToInt()

    val fat = food.fat * amount.hundredGrams
    val fatDisplayValue: LString = Units.Gram.format(fat)

    val carbohydrates = food.carbohydrates * amount.hundredGrams
    val carbohydratesDisplayValue: LString = Units.Gram.format(carbohydrates)

    val fiber = food.fiber * amount.hundredGrams
    val fiberDisplayValue: LString = Units.Gram.format(fiber)

    val protein = food.protein * amount.hundredGrams
    val proteinDisplayValue: LString = Units.Gram.format(protein)

    val isLiquid = food.isLiquid
}

fun FoodUiOptions.toOptions() = FoodOptions(
    date = date,
    amount = amountGrams,
    name = foodName,
    isLiquid = isLiquid,
    calories = calories,
    fat = fat,
    carbohydrates = carbohydrates,
    fiber = fiber,
    protein = protein,
    tablespoon = food.tablespoon,
    cups = food.cups,
    pieces = food.pieces,
    portion = food.portion,
    unit = amount.unit.toFoodUnit(),
)